import { Instant3cn81rq2kpflk as Instant } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { InstantIso8601Serializer_getInstance2sfqqbic5n1oz as InstantIso8601Serializer_getInstance } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/InstantSerializers.mjs';
import { ContextualSerializer1uidivg94sh5v as ContextualSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/ContextualSerializer.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  AdminTitleFields119drm0zwfxoa as AdminTitleFields,
  AdminTableColumns2kd3zhffh08h8 as AdminTableColumns,
} from '../../lightningdb/Annotations.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../DefaultClock.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  IntSerializer_getInstance2q7s8kvk1il5u as IntSerializer_getInstance,
  StringSerializer_getInstance2wffkbpdux3h9 as StringSerializer_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { HasId2loj0ucxxxo6d as HasId } from '../../lightningdb/HasId.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function ReportedExceptionGroup$Companion$$childSerializers$_anonymous__w6ckjd() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.i32_1 = [null, lazy(tmp_0, ReportedExceptionGroup$Companion$$childSerializers$_anonymous__w6ckjd), null, null, null, null, null];
      }
      k2a() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.exceptions.ReportedExceptionGroup', this, 7);
        tmp0_serialDesc.a1b('_id', false);
        tmp0_serialDesc.a1b('lastOccurredAt', true);
        tmp0_serialDesc.a1b('count', true);
        tmp0_serialDesc.a1b('context', false);
        tmp0_serialDesc.a1b('server', false);
        tmp0_serialDesc.a1b('message', false);
        tmp0_serialDesc.a1b('trace', false);
        tmp0_serialDesc.c1b(new (AdminTitleFields())(['message']));
        tmp0_serialDesc.c1b(new (AdminTableColumns())(['message', 'lastOccurredAt', 'count']));
        this.y4l_1 = tmp0_serialDesc;
      }
      z4l(encoder, value) {
        var tmp0_desc = this.y4l_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance().i32_1;
        tmp1_output.v14(tmp0_desc, 0, value.n32_1);
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 1)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance).b1m();
          tmp = !value.o32_1.equals(tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.o32_1);
        }
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.p32_1 === 1)) {
          tmp1_output.v14(tmp0_desc, 2, value.p32_1);
        }
        tmp1_output.a15(tmp0_desc, 3, value.q32_1);
        tmp1_output.a15(tmp0_desc, 4, value.r32_1);
        tmp1_output.a15(tmp0_desc, 5, value.s32_1);
        tmp1_output.a15(tmp0_desc, 6, value.t32_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.z4l(encoder, value instanceof ReportedExceptionGroup() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.y4l_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = 0;
        var tmp5_local1 = null;
        var tmp6_local2 = 0;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_input = decoder.l13(tmp0_desc);
        var tmp12_cached = Companion_getInstance().i32_1;
        if (tmp11_input.a14()) {
          tmp4_local0 = tmp11_input.q13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp11_input.x13(tmp0_desc, 1, tmp12_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp11_input.q13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp11_input.v13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp11_input.v13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.v13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp11_input.q13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp11_input.x13(tmp0_desc, 1, tmp12_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp11_input.q13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp11_input.v13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp11_input.v13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.v13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp11_input.m13(tmp0_desc);
        return ReportedExceptionGroup().a4m(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      az() {
        return this.y4l_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance().i32_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [IntSerializer_getInstance(), tmp0_cached[1].f2(), IntSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var ReportedExceptionGroupClass;
function ReportedExceptionGroup() {
  if (ReportedExceptionGroupClass === VOID) {
    class $ {
      constructor(_id, lastOccurredAt, count, context, server, message, trace) {
        Companion_getInstance();
        var tmp;
        if (lastOccurredAt === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance).b1m();
        } else {
          tmp = lastOccurredAt;
        }
        lastOccurredAt = tmp;
        count = count === VOID ? 1 : count;
        this.n32_1 = _id;
        this.o32_1 = lastOccurredAt;
        this.p32_1 = count;
        this.q32_1 = context;
        this.r32_1 = server;
        this.s32_1 = message;
        this.t32_1 = trace;
      }
      f40() {
        return this.n32_1;
      }
      b4m(_id, lastOccurredAt, count, context, server, message, trace) {
        return new (ReportedExceptionGroup())(_id, lastOccurredAt, count, context, server, message, trace);
      }
      v32(_id, lastOccurredAt, count, context, server, message, trace, $super) {
        _id = _id === VOID ? this.n32_1 : _id;
        lastOccurredAt = lastOccurredAt === VOID ? this.o32_1 : lastOccurredAt;
        count = count === VOID ? this.p32_1 : count;
        context = context === VOID ? this.q32_1 : context;
        server = server === VOID ? this.r32_1 : server;
        message = message === VOID ? this.s32_1 : message;
        trace = trace === VOID ? this.t32_1 : trace;
        return $super === VOID ? this.b4m(_id, lastOccurredAt, count, context, server, message, trace) : $super.b4m.call(this, _id, lastOccurredAt, count, context, server, message, trace);
      }
      toString() {
        return 'ReportedExceptionGroup(_id=' + this.n32_1 + ', lastOccurredAt=' + this.o32_1.toString() + ', count=' + this.p32_1 + ', context=' + this.q32_1 + ', server=' + this.r32_1 + ', message=' + this.s32_1 + ', trace=' + this.t32_1 + ')';
      }
      hashCode() {
        var result = this.n32_1;
        result = imul(result, 31) + this.o32_1.hashCode() | 0;
        result = imul(result, 31) + this.p32_1 | 0;
        result = imul(result, 31) + getStringHashCode(this.q32_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.r32_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.s32_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.t32_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ReportedExceptionGroup()))
          return false;
        if (!(this.n32_1 === other.n32_1))
          return false;
        if (!this.o32_1.equals(other.o32_1))
          return false;
        if (!(this.p32_1 === other.p32_1))
          return false;
        if (!(this.q32_1 === other.q32_1))
          return false;
        if (!(this.r32_1 === other.r32_1))
          return false;
        if (!(this.s32_1 === other.s32_1))
          return false;
        if (!(this.t32_1 === other.t32_1))
          return false;
        return true;
      }
      static a4m(seen0, _id, lastOccurredAt, count, context, server, message, trace, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(121 === (121 & seen0))) {
          throwMissingFieldException(seen0, 121, $serializer_getInstance().y4l_1);
        }
        var $this = createThis(this);
        $this.n32_1 = _id;
        if (0 === (seen0 & 2)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.o32_1 = get_default(Companion_instance).b1m();
        } else
          $this.o32_1 = lastOccurredAt;
        if (0 === (seen0 & 4))
          $this.p32_1 = 1;
        else
          $this.p32_1 = count;
        $this.q32_1 = context;
        $this.r32_1 = server;
        $this.s32_1 = message;
        $this.t32_1 = trace;
        return $this;
      }
    }
    initMetadataForClass($, 'ReportedExceptionGroup', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance});
    ReportedExceptionGroupClass = $;
  }
  return ReportedExceptionGroupClass;
}
//region block: exports
export {
  ReportedExceptionGroup as ReportedExceptionGroup2cus8du9ms53g,
  Companion_getInstance as Companion_getInstance13bmzv5tuee6,
};
//endregion

//# sourceMappingURL=ReportedException.mjs.map
